/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  getAddressEncoder,
  getProgramDerivedAddress,
  getUtf8Encoder,
  type Address,
  type ProgramDerivedAddress,
} from "@solana/kit";

export type TokenVaultSeeds = {
  /** The token mint address */
  tokenMint: Address;
  /** The pool address */
  pool: Address;
};

/**
 * A token vault account that holds tokens for a specific pool.
 * Each pool has separate vaults for token A and token B.
 */
export async function findTokenVaultPda(
  seeds: TokenVaultSeeds,
  config: { programAddress?: Address | undefined } = {},
): Promise<ProgramDerivedAddress> {
  const {
    programAddress = "cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG" as Address<"cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG">,
  } = config;
  return await getProgramDerivedAddress({
    programAddress,
    seeds: [
      getUtf8Encoder().encode("token_vault"),
      getAddressEncoder().encode(seeds.tokenMint),
      getAddressEncoder().encode(seeds.pool),
    ],
  });
}
